import { InjectionToken } from '@angular/core';
import { ResourcesConfig } from 'aws-amplify';

export interface EnvironmentConfig {
  production: boolean;
  i18nPath: string;
  robotNoIndex: boolean;
  apiConfig: ApiConfig;
  urlConfig: UrlConfig;
}

export interface ApiConfig {
  apiName: string;
  amplifyConfig: ResourcesConfig;
}

export interface UrlConfig {
  baseDomain: string;
  appUrlWithoutSubdomain: string;
  appUrlWithSubdomain: (subdomain: string | undefined) => string;
  backofficeUrl: string;
  backofficeRegisterUrl: string;
  baseUrl: string;
  demoUrl: string;
  userContentBucketUrl: string;
}

export const API_CONFIG = new InjectionToken<ApiConfig>('API_CONFIG');
